var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorchHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1269 3.99799C24.0575 1.81078 25.8117 0 28 0C30.1883 0 31.9425 1.81078 31.8731 3.99799L30.2927 53.7789C30.2534 55.0168 29.2385 56 28 56C26.7615 56 25.7466 55.0168 25.7073 53.7789L24.1269 3.99799Z",
    fill: "#0D38D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H44L40.878 16H15.122L12 0Z",
    fill: "#0D38D5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21.6667,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#0D38D5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29.6667,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#0D38D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorchHandle);
export default __webpack_public_path__ + "static/media/torch-handle.500744398fe5133149571747d1d5aded.svg";
export { ForwardRef as ReactComponent };